import { MemreFlexBox, MemreIcon } from './index';
import { Color } from 'core';

export default function MemreBoxSelection({ cardTypes, handleCardClick, width = '80px' }) {
  return (
    <MemreFlexBox direction="row" gap={1} justify="center" align="center" sx={{ p: 1, flex: 1 }}>
      {cardTypes.map((card) => (
        <div key={card.type} onClick={() => handleCardClick(card.type)} style={{ cursor: 'pointer' }}>
          <MemreFlexBox
            direction="column"
            align="center"
            gap={1}
            sx={{
              p: 2,
              border: `1px solid ${Color.lightGray}`,
              borderRadius: '8px',
              width,
              height: '50px',
              textAlign: 'center',
              transition: 'all 0.2s',
              backgroundColor: 'white',
              '&:hover': {
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                transform: 'translateY(-2px)',
              },
            }}
          >
            <MemreIcon iconName={card.icon} fontSize="1.5em" color={Color.textGray} />
            <span style={{ fontSize: '0.8em', fontWeight: 500, marginTop: '2px' }}>
              {card.type.charAt(0).toUpperCase() + card.type.slice(1)}
            </span>
          </MemreFlexBox>
        </div>
      ))}
    </MemreFlexBox>
  );
}
